import { AuthorizedRoute } from '@paycor/pacl';
import { Switch } from 'react-router-dom';
import MainContentAdminComponent from '../../paths-web/admin/Application';
import MainContentComponent from '../../paths-web/client/Application';
import Unauthorized from '../../views/common/unauthorized/Unauthorized';
import CacheHeartbeat from '../CacheHeartbeat';
import ErrorBoundary from '../../paths-web/shared/containers/ErrorBoundary';

export default function Paths() {
    return (
        <>
            <ErrorBoundary fallback={<p>Please Refresh Page</p>}>
                <Switch>
                    <AuthorizedRoute exact path={'/manage'} component={MainContentAdminComponent} />
                    <AuthorizedRoute exact path={'/forbidden'} component={Unauthorized} />
                    <AuthorizedRoute exact path={`*`} component={MainContentComponent} />
                </Switch>
                {/* The cache TTL is one hour, and is populated again after 50 minutes, so send a heartbeat every 51 minutes */}
                <CacheHeartbeat heartbeatInterval={51 * 60_000}></CacheHeartbeat>
            </ErrorBoundary>
        </>
    );
}
